import { render } from "./ConvertPoint.vue?vue&type=template&id=92e0635a"
import script from "./ConvertPoint.vue?vue&type=script&lang=js"
export * from "./ConvertPoint.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__